import React from "react";
import { DateTime } from "luxon";

// mui components
import { TableCell, TableRow } from "@mui/material";

// custom components
import Body2 from "../../typography/body-02";

const MessageRow = ({ row, onMessageRowClick, isAdmin }) => {
	const handleRowClick = () => {
		if (isAdmin && onMessageRowClick) {
			onMessageRowClick(row?.id);
		}
	};

	const formatDate = (isoDateString) => {
		if (!isoDateString) return "";
		try {
			const date = DateTime.fromISO(isoDateString, { zone: "utc" });
			if (date.isValid) {
				return date.toFormat("LLL dd yyyy");
			}
			return isoDateString;
		} catch (err) {
			return isoDateString;
		}
	};

	const formatDateTime = (isoDateString) => {
		if (!isoDateString) return "";
		try {
			const date = DateTime.fromISO(isoDateString, { zone: "utc" });
			if (date.isValid) {
				return date.toFormat("LLL dd yyyy, HH:mm");
			}
			return isoDateString;
		} catch (err) {
			return isoDateString;
		}
	};

	return (
		<TableRow
			hover
			tabIndex={-1}
			onClick={handleRowClick}
			style={{ cursor: isAdmin ? "pointer" : "default" }}
		>
			{/* subject */}
			<TableCell>
				<Body2 text={row?.title} />
			</TableCell>

			{/* details */}
			<TableCell>
				<Body2 text={row?.body} />
			</TableCell>

			{/* date created */}
			{isAdmin && (
				<TableCell>
					<Body2 text={formatDate(row?.created_at)} />
				</TableCell>
			)}

			{/* start date time */}
			<TableCell>
				<Body2 text={formatDateTime(row?.start_date)} />
			</TableCell>

			{/* end date time */}
			<TableCell>
				<Body2 text={formatDateTime(row?.end_date)} />
			</TableCell>
		</TableRow>
	);
};

export default MessageRow;
